export default __webpack_public_path__ + "static/media/vinho_periquita_tinto.b411d23f.png";